import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [activeYear, setActiveYear] = useState(null);

  // ================= NEWSLETTER DATA =================
  const newsletters = [
    {
      year: "2026",
      link: "#",
      months: [
        {
          id: "jan",
          name: "January",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2026/AIIFA-Newsletter-Jan-2026.pdf",
        },
        {
          id: "feb",
          name: "February",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2026/AIIFA-Newsletter-Feb.2026.pdf",
        },
        {
          id: "mar",
          name: "March",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2026/AIIFA-Newsletter-March-2026.pdf",
        },
        {
          id: "apr",
          name: "April",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2026/AIIFA-newsletter-april-2026.pdf",
        },
        {
          id: "may",
          name: "May",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2026/AIIFA-newsletter-may-2026.pdf",
        },
        {
          id: "June",
          name: "June",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2026/AIIFA-newsletter-june-2026.pdf",
        },
        {
          id: "July",
          name: "July",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2026/AIIFA-newsletter-july-2026.pdf",
        },
        {
          id: "August",
          name: "August",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2026/AIIFA-newsletter-august-2026.pdf",
        },
        {
          id: "September",
          name: "September",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2026/AIIFA-Newsletter-sept-2026.pdf",
        },
        {
          id: "October",
          name: "October",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2026/AIIFA-Newsletter-oct-2026.pdf",
        },

      ],
    },
    {
      year: "2025",
      link: "/newsletter-2025",
      months: [
        {
          id: "dec",
          name: "December",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2025/AIIFA-Newsletter-Dec-2025_compressed.pdf",
        },
        {
          id: "nov",
          name: "November",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2025/AIIFA-Newsletter-Nov-2025.pdf",
        },
        {
          id: "aug-oct",
          name: "Aug – Oct",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2025/Newsletter-Aug-to-Oct-2025.pdf",
        },
        {
          id: "jul",
          name: "July",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2025/Newsletter-July-2025.pdf",
        },
        {
          id: "jun",
          name: "June",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2025/Newsletter-June-2025-1.pdf",
        },
        {
          id: "may",
          name: "May",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2025/Newsletter-May-2025-1.pdf",
        },
        {
          id: "apr",
          name: "April",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2025/Newsletter-April-2025-4.pdf",
        },
        {
          id: "mar",
          name: "March",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2025/Newsletter-March-2025-final.pdf",
        },
        {
          id: "feb",
          name: "February",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2025/Newsletter-Feb-2025-3.pdf",
        },
        {
          id: "jan",
          name: "January",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2025/Newsletter-Jan-2025.pdf",
        },
      ],
    },

    {
      year: "2024",
      link: "/newsletter-2024",
      months: [
        {
          name: "December",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/December-Newsletter-2024-6.pdf",
        },
        {
          name: "November",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/November-new-Newsletter-2024.pdf",
        },
        {
          name: "October",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/October-Newsletter-2024-1.pdf",
        },
        {
          name: "September",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/Sept-Newsletter-2024.pdf",
        },
        {
          name: "July – August",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/July-August-Newsletter-2024.pdf",
        },
        {
          name: "June",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/Newsletter-June-2024-new-4.pdf",
        },
        {
          name: "May",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/Newsletter-May-2024-2.pdf",
        },
        {
          name: "April",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/Newsletter-April-2024-4.pdf",
        },
        {
          name: "March",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/Newsletter-March-2024-3.pdf",
        },
        {
          name: "February",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/Newsletter-Feb-2024.pdf",
        },
        {
          name: "January",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2024/Newsletter-Jan-2024.pdf",
        },
      ],
    },

    {
      year: "2023",
      link: "/newsletter-2023",
      months: [
        {
          name: "December",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2023/Newsletter-Dec-curve-2023.pdf",
        },
        {
          name: "November",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2023/Newsletter-Nov-2023-final.pdf",
        },
        { name: "October", pdfUrl: "#" },
        {
          name: "September",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2023/September-2023-2.pdf",
        },
        {
          name: "May",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2023/May-2023-3.pdf",
        },
        {
          name: "April",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2023/April-newsletter-2023.pdf",
        },
        {
          name: "March",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2023/march_2023.pdf",
        },
        {
          name: "February",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2023/feb_2023_final.pdf",
        },
        {
          name: "January",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2023/Jan_2023_final.pdf",
        },
      ],
    },

    {
      year: "2022",
      link: "/newsletter-2022",
      months: [
        {
          name: "December",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2022/December-final-2022.pdf",
        },
        {
          name: "November",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2022/Newsletter-November-2022.pdf",
        },
        {
          name: "October",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2022/Newsletter-October-curve-2022.pdf",
        },
        {
          name: "September",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2022/Newsletter-SEPT.-2022.pdf",
        },
        {
          name: "August",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2022/August-Newsletter-2022.pdf",
        },
        {
          name: "July",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2022/Newsletter-July-2022.pdf",
        },
        {
          name: "April – June",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2022/April-May-June-2022.pdf",
        },
        {
          name: "March",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2022/Newsletter-March-2022-4.pdf",
        },
        {
          name: "February",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2022/Newsletter-of-Feb-2022.pdf",
        },
        {
          name: "January",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2022/Newsletter-Jan-2022.pdf",
        },
      ],
    },

    {
      year: "2021",
      link: "/newsletter-2021",
      months: [
        {
          name: "December",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2021/Newsletter-November-2021-curve.pdf",
        },
        { name: "November", pdfUrl: "#" },
        {
          name: "October",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2021/Sep-Newsletter-2021.pdf",
        },
        {
          name: "September",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2021/Newsletter-August.pdf",
        },
        {
          name: "August",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2021/Newsletter-July-2.pdf",
        },
        {
          name: "July",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2021/Newsletter-June.-2021-1.pdf",
        },
        { name: "June", pdfUrl: "#" },
        {
          name: "April",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2021/Newsletter-April.-2021.pdf",
        },
        {
          name: "March",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2021/Newsletter-March-2021.pdf",
        },
        {
          name: "February",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2021/Newsletter-feb.-2021-final.pdf",
        },
        {
          name: "January",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2021/Newsletter-January-12021-curve.pdf",
        },
      ],
    },

    {
      year: "2020",
      link: "/newsletter-2020",
      months: [
        {
          name: "December",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2020/Newsletter-December-Final-2020.pdf",
        },
        { name: "November", pdfUrl: "#" },
        {
          name: "October",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2020/NewsletterOctober-2020-1.pdf",
        },
        {
          name: "September",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2020/Newsletter-september-curve-2020.pdf",
        },
        {
          name: "August",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2020/Newsletter-August-2020-2.pdf",
        },
        {
          name: "July",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2020/Newsletter-July-2020.pdf",
        },
      ],
    },

    {
      year: "2019",
      link: "/newsletter-2019",
      months: [
        {
          name: "November",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2019/November-2019.pdf",
        },
        {
          name: "October",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2019/Newsletter-October-2019.pdf",
        },
        {
          name: "September",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2019/Newsletter-September-2019.pdf",
        },
        { name: "August", pdfUrl: "#" },
        {
          name: "July",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2019/Newsletter-July-2019.pdf",
        },
        {
          name: "June",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2019/Newsletter-June-2019.pdf",
        },
        {
          name: "May",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2019/Newsletter-May-2019.pdf",
        },
        {
          name: "April",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2019/Newsletter-April-2019.pdf",
        },
        {
          name: "March",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2019/Newsletter-March-2019.pdf",
        },
        {
          name: "February",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2019/Newsletter-Feb-2019.pdf",
        },
        {
          name: "January",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2019/Newsletter-Jan-2019.pdf",
        },
      ],
    },
    {
      year: "2018",
      link: "/newsletter-2018",
      months: [
        {
          name: "December",
          link: "/newsletter-2018-dec",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2018/Newsletter-Dece-2018-3.pdf",
        },
        {
          name: "November",
          link: "/newsletter-2018-nov",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2018/Newsletter-Oct-Nov-2018.pdf",
        },
        {
          name: "October",
          link: "/newsletter-2018-oct",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2018/Newsletter-Oct-Nov-2018.pdf",
        },
        {
          name: "September",
          link: "/newsletter-2018-sep",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2018/Sep-Newsletter-2018-special-edition-email.pdf",
        },
        {
          name: "August",
          link: "/newsletter-2018-aug",
          pdfUrl:
            "https://hoverbbusinessservices.com/cloud/aiifa/newsletters/2018/Newsletter-August-2018-2.pdf",
        },
        {
          name: "July",
          link: "/newsletter-2018-jul",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2018/Newsletter-July-2018-1.pdf",
        },
        {
          name: "June",
          link: "/newsletter-2018-jun",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2018/Newsletter-June-2018-Final-1.pdf",
        },
        {
          name: "May",
          link: "/newsletter-2018-may",
          pdfUrl: "#",
        },
        {
          name: "April",
          link: "/newsletter-2018-apr",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2018/Newsletter-April-2018-FINAL-curve.pdf",
        },
        {
          name: "March",
          link: "/newsletter-2018-mar",
          pdfUrl: "#",
        },
        {
          name: "February",
          link: "/newsletter-2018-feb",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2018/newsletter-Feb-final-2018-1.pdf",
        },
        {
          name: "January",
          link: "/newsletter-2018-jan",
          pdfUrl:
            "https://cloud.hoverbusinessservices.com/aiifa/newsletters/2018/newsletter-jan-2018-for-website.pdf",
        },
      ],
    },
  ];

  // ================= SUBMIT HANDLER =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage(
      "Thank you for subscribing! You’ll now receive our latest updates.",
    );
    setEmail("");
    setTimeout(() => setSuccessMessage(""), 4000);
  };

  return (
    <section className="newsletter-page py-5">
      <Container>
        <Row>
          {/* LEFT: CURRENT NEWSLETTER */}
          <Col lg={8} className="mb-4">
            <h2 className="our-team-title mb-3">Current Newsletter – 2026</h2>

            <iframe
              src={newsletters[0].months[newsletters[0].months.length - 1].pdfUrl}
              width="100%"
              height="700px"
              title="Current Newsletter"
              style={{ border: "1px solid #ccc" }}
            />
          </Col>

          {/* RIGHT: SIDEBAR */}
          <Col lg={4}>
            <div className="newsletter-sidebar p-4 shadow mt-5">
              <h4 className="mb-3">Previous Newsletters</h4>

              <ul className="newsletter-year-list">
                {newsletters.map((item, index) => (
                  <li
                    key={index}
                    className="newsletter-year-item"
                    onMouseEnter={() => setActiveYear(item.year)}
                    onMouseLeave={() => setActiveYear(null)}
                  >
                    {/* YEAR CLICK (opens latest PDF) */}
                    <a 
                    // href={item.link} 
                    className="newsletter-year-link">
                      {item.year} Newsletter
                    </a>

                    <span className="newsletter-arrow">▾</span>

                    {/* MONTH DROPDOWN */}
                    {activeYear === item.year && (
                      <ul className="newsletter-month-dropdown">
                        {item.months.map((month, i) => (
                          <li key={i}>
                            {month.pdfUrl && month.pdfUrl !== "#" ? (
                              <a
                                href={month.pdfUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {month.name}
                              </a>
                            ) : (
                              <span className="newsletter-month-disabled">
                                {month.name}
                              </span>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>

              {/* SUBSCRIBE BOX */}
              <div className="subscribe-box mt-5">
                <h5 className="mb-2">Subscribe to Newsletter</h5>

                <form onSubmit={handleSubmit}>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="form-control mb-3"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />

                  <button type="submit" className="btn btn-newsletter w-100">
                    Subscribe
                  </button>
                </form>

                {successMessage && (
                  <div className="success-toast">{successMessage}</div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
